<div *ngIf="fleets && fleets.length > 0" class="global-search">
	<ng-template #searchResult let-r="result" let-t="term">
		<ngb-highlight result="{{r.category}}: {{r.name}} {{r.serial ? '(SN: ' + r.serial + ')' : ''}} {{r.obcu && r.obcu.toLowerCase().indexOf(t.toLowerCase()) > -1 ? '(OBCU: ' + r.obcu + ')' : ''}}" [term]="t"></ngb-highlight>
	</ng-template>
	<div class="form-group row">
		<label class="col-sm-4">Search all fleets / assets:</label>
		<div class="col-sm-8">
			<input [ngModel]="searchText" (ngModelChange)="searchText = $event" [ngbTypeahead]="searchFunc" [editable]="false" [ngb-highlight]="searchText" [resultTemplate]="searchResult"
				(selectItem)="searchNav($event.item)" type="text" class="form-control">
		</div>
	</div>
</div>
<div *ngIf="!api.user?.support">
	<nav class="breadcrumb">
		<span class="breadcrumb-item active">My {{brand.fleetPlural}}</span>
	</nav>
	<app-fleet-summary [routerLink]="['fleet', fleet.fleet_id]" [fleet]="fleet" *ngFor="let fleet of fleets" class="clickable"></app-fleet-summary>
	<div *ngIf="fleets && fleets.length === 0" class="no-fleets">You have no {{brand.fleetPlural | lowercase}} to view</div>
</div>
<div *ngIf="api.user?.support">
	<div *ngFor="let org of orgs">
		<nav class="breadcrumb">
			<span class="breadcrumb-item active">{{org.name}} {{brand.fleetPlural}}</span>
		</nav>
		<app-fleet-summary [routerLink]="['fleet', fleet.fleet_id]" [fleet]="fleet" *ngFor="let fleet of org.fleets" class="clickable"></app-fleet-summary>
		<div *ngIf="org.fleets && org.fleets.length === 0" class="no-fleets">You have no {{brand.fleetPlural | lowercase}} to
			view</div>
	</div>
</div>
<div *ngIf="fleets === undefined" class="text-center pt-3 pb-5">
	<div class="logo-spin light"></div>
	Loading fleets...
</div>